import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { CHANGE_TAB } from "../../constants/actionTypes";
import { profileUpdateService } from "../../Network/services/profileUpdateService";
import { useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Files from "react-files";
import { LoadingOverlay, Loader } from "react-overlay-loader";

import WebcamCapture from "./WebcamCapture";

import "react-datepicker/dist/react-datepicker.css";
import "react-tagsinput/react-tagsinput.css";
import "react-toastify/dist/ReactToastify.css";

const mapStateToProps = (state) => ({
  ...state.articleList,
});

const mapDispatchToProps = (dispatch) => ({
  onTabClick: (tab, pager, payload) =>
    dispatch({ type: CHANGE_TAB, tab, pager, payload }),
});

const VerifyUser = (props) => {
  
  let location = useLocation();
  let history = useHistory();
  
  const [loading, setLoading] = useState(false);

  const [name, setName] = useState("");


  const randomString = (length) => {
    const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';
    for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  }
 
  
  const getFileFromWebcam = (fileData) => {
   
    const userInfo = fileData;
    // const videoBlob = Array.isArray(fileData) ? fileData[0] : fileData;

    // if (videoBlob instanceof Blob) {
    //   try {
    //     const reader = new FileReader();
    //     reader.onloadend = () => {
    //       const base64data = reader.result;
    //       const storageData = JSON.stringify({
    //         type: 'base64',
    //         data: base64data,
    //         mimeType: videoBlob.type || 'video/mp4',
    //         timestamp: new Date().toISOString()
    //       });
    //       localStorage.setItem('kycVerificationData', storageData);
    //     };
    //     reader.onerror = (error) => {
    //       console.error('Error converting blob to base64:', error);
    //     };
    //     reader.readAsDataURL(videoBlob);
    //   } catch (error) {
    //     console.error('Error processing video blob:', error);
    //   }
    // }

    history.push({ 
      pathname: '/ekycEdit',
      state: { userInfo: userInfo }
     });
  }

  const getIsCameraActive = (fileData) => {

    if(fileData=="nocamera"){
      history.push({ 
        pathname: '/profile'
       });
    }
  }
 
  useEffect(() => {
    window.scrollTo(0, 0)
  
    let user = JSON.parse(window.localStorage.getItem("UserData"));
    setName(user.first_name + " " + user.last_name);
    
 
  }, []);

  let back = (e) => {
    e.preventDefault();
    history.goBack();
  };

  return (
    <section className="explore explore1">
    <LoadingOverlay>
    <div className="container">
      <div className="row">
        <div className="banner">
          <div className="row">
            <div className="col-md-4">
              <div className="breadcrumps">
                <ul>
                  <li>
                    <a href="#!" onClick={(e) => back(e)}>
                      <i className="bx bx-chevron-left" /> Back to View demo
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <section className="onbord-section">
        <WebcamCapture uname={name} captcha={randomString(6)} getFile={getFileFromWebcam} isCamera={getIsCameraActive} />
        </section>
      </div>
    </div>
     
      <Loader loading={loading} />
    </LoadingOverlay>
    
    </section>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyUser);
